import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Constants} from '../../common/constants';
import {FieldConfigName} from '../../../models';
import {ControlDialogOptionsHelper} from '../control-dialog-options-helper';

@Component({
  selector: 'app-text-input-dialog',
  templateUrl: './label-input-dialog.component.html'
})
export class LabelInputDialogComponent extends ControlDialogOptionsHelper implements OnInit {
  constants: any = Constants;
  editLabelInputForm: UntypedFormGroup;
  control: FieldConfigName;
  formats = [
    'bold',
    'italic',
    'blockquote',
    'color',
    'background',
    'header',
    'list',
    'indent',
    'link',
    'clean',
  ];

  modules = {
    toolbar: [
      ['bold', 'italic'],
      ['blockquote'],
      [{'color': []}, {'background': []}],
      [{'header': [1, 2, 3, 4, 5, 6, false]}],
      [{'list': 'ordered'}, {'list': 'bullet'}],
      [{'indent': '-1'}, {'indent': '+1'}],
      ['link'],
      ['clean']
    ]
  };

  constructor(private formBuilder: UntypedFormBuilder,
              public dialogRef: MatDialogRef<LabelInputDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    if (data) {
      this.control = data.control || this.control;
    }
  }

  ngOnInit(): void {
    this._initForm();
    this._initFormValues(this.control);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.editLabelInputForm.invalid) {
      return;
    }
    this.dialogRef.close(this.editLabelInputForm.value);
  }

  private _initForm(): void {
    this.editLabelInputForm = this.formBuilder.group({
      tooltip: ['', []],
      label: ['', []],
      placeholder: ['', []],
      isRequired: [false],
      content: ['', []],
    });
  }

  private _initFormValues(control: any): void {
    this.editLabelInputForm.setValue({
      tooltip: control.options.tooltip,
      label: control.options.label,
      placeholder: control.options.placeholder,
      isRequired: control.options.isRequired,
      content: control.options.content,
    });
  }
}
